import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import BottomNavigation from "./BottomNavigation";

export default function AppLayout({ children, onLogout, user }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        bgcolor: "#f5f6fa",
        flexDirection: isMobile ? "column" : "row"
      }}
    >
      {/* Sidebar - visible on desktop, hidden on mobile */}
      {!isMobile && <Sidebar />}

      {/* Mobile drawer - visible when toggled on mobile */}
      {isMobile && (
        <Sidebar
          open={drawerOpen}
          onClose={handleDrawerToggle}
          isModal={true}
        />
      )}

      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          width: "100%",
          mb: isMobile ? 7 : 0 // Add margin for bottom nav on mobile
        }}
      >
        <Topbar
          onLogout={onLogout}
          user={user}
          onMenuClick={isMobile ? handleDrawerToggle : undefined}
          isMobile={isMobile}
        />

        <Box
          sx={{
            p: isMobile ? 2 : 3,
            overflowY: "auto",
            flexGrow: 1
          }}
        >
          {children}
        </Box>
      </Box>

      {/* Bottom Navigation - visible on mobile only */}
      {isMobile && <BottomNavigation onClose={handleDrawerToggle} />}
    </Box>
  );
}